var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.initialized
    ? _c(
        "section",
        { staticClass: "migration" },
        [
          _vm.isLoggedIn
            ? [
                _c("h1", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("migration.verify.loggedInTitle"))
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "migration__text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("migration.verify.loggedInText"))
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.$t("migration.verify.loggedInButton")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.goToAccount.apply(null, arguments)
                    }
                  }
                })
              ]
            : !_vm.error && !_vm.isLoggedIn
            ? [
                _c("h1", {
                  domProps: { innerHTML: _vm._s(_vm.$t("migration.title")) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "migration__wrapper" }, [
                  _c("div", { staticClass: "migration__column" }, [
                    _c("div", { staticClass: "migration__intro" }, [
                      _c("div", {
                        staticClass: "migration__text",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("migration.userBrandsText"))
                        }
                      }),
                      _vm._v(" "),
                      _vm.userBrands.length
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "migration__brands migration__brands--user"
                            },
                            _vm._l(_vm.userBrands, function(brand) {
                              return _c(
                                "li",
                                {
                                  key: brand.code,
                                  staticClass:
                                    "migration__brand migration__brand--user",
                                  class: {
                                    "migration__brand--current": brand.current
                                  }
                                },
                                [
                                  _c(
                                    _vm.iconComponent(
                                      "logo-simple-" + brand.code
                                    ),
                                    {
                                      tag: "component",
                                      staticClass: "migration__brand-logo"
                                    }
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "migration__text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("migration.userBrandsSubText")
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "migration__highlights" }, [
                      _c("div", {
                        staticClass:
                          "migration__text migration__text--highlight",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("migration.highlightText"))
                        }
                      }),
                      _vm._v(" "),
                      _vm.migrationBrands.length
                        ? _c(
                            "ul",
                            {
                              staticClass:
                                "migration__brands migration__brands--all"
                            },
                            _vm._l(_vm.migrationBrands, function(brand) {
                              return _c(
                                "li",
                                {
                                  key: brand.code,
                                  staticClass:
                                    "migration__brand migration__brand--all",
                                  class: {
                                    "migration__brand--current": brand.current
                                  }
                                },
                                [
                                  _c(
                                    _vm.iconComponent(
                                      "logo-simple-" + brand.code
                                    ),
                                    {
                                      tag: "component",
                                      staticClass: "migration__brand-logo"
                                    }
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "migration__column" }, [
                    _c("div", { staticClass: "migration__advantages" }, [
                      _c("h2", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("migration.advantagesTitle"))
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "migration__text",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("migration.advantagesText"))
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "migration__questions" }, [
                      _c("h2", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("migration.questionsTitle"))
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "migration__text" },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("migration.questionsText")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: {
                              level: "tertiary",
                              type: "button",
                              text: _vm.$t("migration.questionsButton"),
                              href: _vm.$t("migration.questionsUrl"),
                              arrow: ""
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "migration__column migration__column--span"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "migration__actions" },
                        [
                          _vm.response.message
                            ? _c("GeneralMessage", {
                                attrs: {
                                  message: _vm.response.message,
                                  type: _vm.response.type
                                },
                                on: {
                                  close: function($event) {
                                    _vm.response.message = ""
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("ValidationObserver", {
                            ref: "form",
                            attrs: { tag: "form", novalidate: "" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.onSubmit.apply(null, arguments)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    var errors = ref.errors
                                    return [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          rules: {
                                            required: { allowFalse: false }
                                          },
                                          name: "checkTerms",
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t("login.errorTerms")
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var invalid = ref.invalid
                                                var errors = ref.errors
                                                var validated = ref.validated
                                                return [
                                                  _c(
                                                    "FormInputCheckbox",
                                                    {
                                                      attrs: {
                                                        name: "terms",
                                                        value: "checkTerms",
                                                        required: "",
                                                        immediate: "",
                                                        disabled: _vm.disabled
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.checkTerms,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "checkTerms",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.checkTerms"
                                                      }
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              "login.termsLabel"
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  invalid && validated
                                                    ? _c("span", {
                                                        staticClass:
                                                          "input-error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            errors[0]
                                                          )
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "migration__buttons" },
                                        [
                                          _c("Button", {
                                            attrs: {
                                              type: "reset",
                                              level: "secondary",
                                              text: _vm.$t(
                                                "migration.cancelButton"
                                              ),
                                              disabled: _vm.disabled
                                            },
                                            on: { click: _vm.onCancel }
                                          }),
                                          _vm._v(" "),
                                          _c("Button", {
                                            attrs: {
                                              type: "submit",
                                              level: "primary",
                                              text: _vm.$t(
                                                "migration.activateButton"
                                              ),
                                              disabled: _vm.disabled
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4066728574
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "migration__options" },
                            [
                              _c("div", {
                                staticClass: "migration__options-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("migration.optionsTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("Button", {
                                attrs: {
                                  level: "tertiary",
                                  type: "button",
                                  text: _vm.$t("migration.newButton"),
                                  arrow: ""
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.onNew.apply(null, arguments)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]
            : [
                _c("h1", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("migration.errorTitle"))
                  }
                }),
                _vm._v(" "),
                _c("GeneralMessage", {
                  attrs: { message: _vm.error, type: "error", stick: "" }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    type: "button",
                    text: _vm.$t("migration.cancelButton")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.onCancel.apply(null, arguments)
                    }
                  }
                })
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }